import { render, staticRenderFns } from "./Styles.vue?vue&type=template&id=2f797ee2&scoped=true&"
import script from "./Styles.vue?vue&type=script&lang=js&"
export * from "./Styles.vue?vue&type=script&lang=js&"
import style0 from "./Styles.vue?vue&type=style&index=0&id=2f797ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f797ee2",
  null
  
)

export default component.exports